import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../../theme';
import Location from '../Location/Location';
import { SegmentFragment, SegmentWithTransferFragment } from '@websky/graphql';
import { getDurationString } from '../../../Results/utils';
import FlightCard from '../../../FlightCard';
import TransferInfo from '../../../TransferInfo';

interface Props {
	className?: string;
	cardClassName?: string;
	transferClassName?: string;
	segment: SegmentWithTransferFragment;
	isReturnFlight?: boolean;
	nextSegment: SegmentFragment;
	isMobile?: boolean;
}

const FlightInfoSegment: React.FC<Props> = ({
	className,
	cardClassName,
	transferClassName,
	segment,
	nextSegment,
	isMobile,
	isReturnFlight
}) => {
	const { FlightInfoSegment: css } = useTheme('DesktopFlight');

	const currentSegment = segment.segment;

	return (
		<div
			className={cn(className, css.wrapper, {
				[css.isMobile]: isMobile
			})}
		>
			<div className={cn(css.card, cardClassName)}>
				<div className={css.locations}>
					<Location
						type="departure"
						className={css.location}
						isMobile={isMobile}
						{...currentSegment.departure}
					/>
					<Location type="arrival" className={css.location} isMobile={isMobile} {...currentSegment.arrival} />
				</div>

				<FlightCard
					className={css.flight}
					airline={currentSegment.operatingAirline}
					flightNumber={`${currentSegment.marketingAirline?.iata}-${currentSegment.flightNumber}`}
					duration={getDurationString(currentSegment.duration)}
					aircraft={currentSegment.aircraft}
					amenities={currentSegment.flightInfo?.amenities}
					markers={currentSegment.flightInfo?.markers}
					statistics={currentSegment.flightInfo?.statistics}
					isReturnFlight={isReturnFlight}
				/>
			</div>

			{(segment.transferDuration || currentSegment?.stops?.length > 0) && (
				<TransferInfo
					classes={{
						transfer: cn(css.transfer, transferClassName),
						technicalLandingIn: css.technicalLandingIn
					}}
					segment={currentSegment}
					nextSegment={nextSegment}
					transferDuration={segment.transferDuration}
					showStops={true}
				/>
			)}
		</div>
	);
};

export default FlightInfoSegment;
